module.exports = __webpack_public_path__ + "img/Tyara-full.f7c238c8.png";